import { ContainerModule } from 'inversify';
import * as Commands from './commands'
import { QuestionAttemptServiceSymbol, QuestionAttemptService } from './question-attempt-service';

export const questionAttemptServiceModule = new ContainerModule((bind) => {
  bind(QuestionAttemptServiceSymbol).to(QuestionAttemptService).inSingletonScope();
  bind(Commands.AddQuestionAttemptCommandHandler).toSelf()
  bind(Commands.QueryQuestionAttemptsTrackingStateCommandHandler).toSelf()
});
